'use strict';

function addDomEvent(target, eventName, handler, options = { passive: true }) {
    target.addEventListener(eventName, handler, options);
    return () => target.removeEventListener(eventName, handler);
}

exports.addDomEvent = addDomEvent;
//# sourceMappingURL=add-dom-event.cjs.map
